// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  recipeId: __t.string().primaryKey().name("recipe_id"),
  baseCookSecondsMs: __t.i64().name("base_cook_seconds_ms"),
  appliance: __t.string(),
  sellPriceCents: __t.i64().name("sell_price_cents"),
  satisfactionX100Base: __t.i32().name("satisfaction_x100_base"),
  category: __t.string(),
  tier: __t.u32(),
});
